export const LAYER_OUT = 0
export const LAYER_PICKING = 1
